import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  expiresLabel: {
    id: 'lHu7Zl',
    defaultMessage: 'Expires {expiration}',
    description: 'Expiration date shown next to a selected payment card',
  },
});
